/* eslint-disable react/forbid-prop-types */

/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState, useCallback, useEffect, useRef, Fragment } from 'react';

import useWindowSize from '../../hooks/useWindowSize';
import * as AppPropTypes from '../../lib/PropTypes';

import TwoStateButton from '../buttons/TwoStateButton';
import CalendarIcon from '../icons/Calendar';
import ListIcon from '../icons/List';
import PillsMenu from './PillsMenu';

import styles from '../../../styles/menus/sticky-menu.module.scss';

const propTypes = {
    className: PropTypes.string,
    groups: PropTypes.arrayOf(
        PropTypes.shape({
            title: AppPropTypes.message,
            items: AppPropTypes.menuItems,
        }),
    ),
    endButtons: PropTypes.node,
    withCalendar: PropTypes.bool,
    isMobileCollapsed: PropTypes.bool,
    onClickPill: PropTypes.func,
    pillClassName: PropTypes.string,
    isDark: PropTypes.bool,
};

const defaultProps = {
    className: null,
    groups: [],
    endButtons: null,
    withCalendar: false,
    isMobileCollapsed: false,
    onClickPill: null,
    pillClassName: null,
    isDark: false,
};

const StickyMenu = ({
    className,
    groups,
    endButtons,
    withCalendar,
    isMobileCollapsed,
    onClickPill,
    pillClassName,
    isDark,
}) => {
    const endButtonsRef = useRef(null);
    const { width: windowWidth } = useWindowSize();

    const [filtersOpened, setFiltersOpened] = useState(false);
    const toggleFilters = useCallback(() => {
        setFiltersOpened(!filtersOpened);
    }, [filtersOpened, setFiltersOpened]);

    useEffect(() => {
        setFiltersOpened(false);
    }, [windowWidth]);

    return (
        <div
            className={classNames(styles.container, {
                [className]: className !== null,
                [styles.withCalendar]: withCalendar === true,
                [styles.canCollapse]: isMobileCollapsed === true,
                [styles.collapsed]: isMobileCollapsed === true && filtersOpened === false,
                [styles.notCollapsed]: isMobileCollapsed === true && filtersOpened === true,
                [styles.isDark]: isDark === true,
            })}
        >
            {isMobileCollapsed ? (
                <TwoStateButton
                    onClick={toggleFilters}
                    opened={filtersOpened}
                    icon={withCalendar ? <CalendarIcon /> : <ListIcon />}
                    className={styles.filtersBtn}
                />
            ) : null}
            <nav className={styles.inner}>
                <div className={styles.pills}>
                    {groups.map(({ items = null, title = null }, idx) => (
                        <Fragment key={`group-${title}-${idx + 1}`}>
                            {title !== null ? <p className={styles.pillsTitle}>{title}</p> : null}
                            <PillsMenu
                                items={items}
                                onClick={onClickPill}
                                className={styles.pillsMenu}
                                pillClassName={pillClassName}
                                isDark
                            />
                        </Fragment>
                    ))}
                </div>
                {endButtons !== null ? (
                    <div ref={endButtonsRef} className={styles.endButtons}>
                        {endButtons}
                    </div>
                ) : null}
            </nav>
        </div>
    );
};

StickyMenu.propTypes = propTypes;
StickyMenu.defaultProps = defaultProps;

export default StickyMenu;
